module.exports = __webpack_public_path__ + "img/mycombo_vip_text_img1.ffb39075.png";